import bannerEn from 'src/icons/banner-en.webp'
import bannerDe from 'src/icons/banner-de.webp'
import bannerRo from 'src/icons/banner-ro.webp'
import bannerEs from 'src/icons/banner-es.webp'
import bannerFr from 'src/icons/banner-fr.webp'
import bannerIt from 'src/icons/banner-it.webp'
import bannerPt from 'src/icons/banner-pt.webp'
import bannerEl from 'src/icons/banner-el.webp'
import bannerSl from 'src/icons/banner-sl.webp'

import type { TLang } from './langs'

export const languageBanners: Record<TLang, string> = {
    en: bannerEn,
    de: bannerDe,
    ro: bannerRo,
    es: bannerEs,
    fr: bannerFr,
    it: bannerIt,
    pt: bannerPt,
    el: bannerEl,
    sl: bannerSl,
}

export const getLanguageBanner = (lang: TLang): string => {
    return languageBanners[lang as TLang] ?? bannerEn
}
